import React, {useState, useEffect} from "react";
import { useParams } from "react-router-dom";
import Navigation from "../partials/Navigation";
import hviCoverImg from "./../images/si-cover.jpg";
import Slider from 'react-rangeslider';
import 'react-rangeslider/lib/index.css';
import hviQuestions from "../utils/hvi-questions";
import {Helmet} from "react-helmet";
import configVars from "../config";
import { setWithExpiry, getWithExpiry } from '../common';
import HorizontalNav from "../partials/Dashboard/HorizontalNav";
//import validator from "validator";
import { useTranslation } from "react-i18next";
import { useCookies } from "react-cookie";
import OfflineHVIResults from "./OfflineHVIResults";
import HviMessages from "../partials/HVI/HviMessages";
import HviPersonalSummary from "../partials/HVI/HviPersonalSummary";

const SustainIndex = () => {

	let intVal = [];

	if ( hviQuestions ) {
		hviQuestions.map( ( hviQuestion ) => 
			hviQuestion.type === 'custom' ? intVal.push({value: ''}) : intVal.push({value: 2})
		)
	}

	const [hviVal, setHviVal] = useState(intVal);
	const [currentStep, setCurrentStep] = useState(0);
	const [saving, setSaving] = useState(false);
	const [hviCount, setHviCount] = useState(0);
	const [displayCount, setDisplayCount] = useState(false);
	//const [modelShow, setModelShow] = useState(false);
	const [showEmail, setShowEmail] = useState(false);
	const [userEmail, setUserEmail] = useState('');
	const [errorMsg, setErrorMsg] = useState('');
	const { group, results } = useParams();
	const [completed, setCompleted] = useState(false);
	const [loading, setLoading] = useState(false);
	const [showResults, setShowResults] = useState(false);
	const [recentHvi, setRecentHvi] = useState([]);
	const [userLang, setUserLang] = useState('sv');

	const [translation] = useTranslation("translations");
	const [cookies] = useCookies(["sc_user_lang"]);

	const [translatedHvuQa, setTranslatedHvuQa] = useState([]);
	const [shortQuestions, setShortQuestions] = useState([]);
	const [displayTest, setDisplayTest] = useState(false);

	const hviLabels = {
		1: '1',
		2: '2',
		3: '3',
		4: '4',
		5: '5',
		6: '6'
	}

	useEffect(() => {

		const queryString = window.location.search;
    	const urlParams = new URLSearchParams(queryString);

		let currentLang = 'sv';

		if (urlParams.get("count")) {

			const count = urlParams.get("count");

			if ( count.length > 0 ) {
				//setHviCount(count);
				setDisplayCount(true);
			}

		} else {
			//setHviCount(0);
			setDisplayCount(false);
		}

		const chosenLang = urlParams.get("lang");
    	const savedLang = cookies?.sc_user_lang;

		if ( chosenLang ) {
			setUserLang( chosenLang );
			currentLang = chosenLang;
		} else if ( savedLang ) {
			setUserLang( savedLang );
			currentLang = savedLang;
		}

		if ( results === 'results' ) {
			setShowResults(true);
		}

        const indexQuestions = getWithExpiry( `sy_sustain_index_questions_${currentLang}` );
		const indexShortQuestions = getWithExpiry( `sy_sustain_index_short_questions_${currentLang}` );

        if ( indexQuestions ) {
            setTranslatedHvuQa( indexQuestions );
			setShortQuestions( indexShortQuestions );
        } else {

            (async () => {

				setLoading(true);
				
                const response = await fetch(
                    `${configVars.apiUrl}sustainchange/v1/getsustainindexquestions/?lang=${currentLang}`,
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Basic ${configVars.auth}`,
                        },
                    }
                );
                
                const hviResponse = await response.json();
    
                if ( hviResponse ) {
                    
                    if ( hviResponse?.questions?.index_questions && hviResponse?.questions?.index_questions?.length > 0 ) {
                        setTranslatedHvuQa( hviResponse?.questions?.index_questions )
                        setWithExpiry( `sy_sustain_index_questions_${currentLang}`, hviResponse?.questions?.index_questions );
                    }

					if ( hviResponse?.questions?.sustain_index_short_questions && hviResponse?.questions?.sustain_index_short_questions?.length > 0 ) {

						const short_qs = hviResponse?.questions?.sustain_index_short_questions.map(x => x.short_question);

						setShortQuestions( short_qs );
						setWithExpiry( `sy_sustain_index_short_questions_${currentLang}`, short_qs );
					}
    
                }

				setLoading(false);
    
            })()

        }

	}, [cookies.sc_user_lang, group, results]);

	const handleHviUpdate = (val, updatedIndex) => {

		const valInt = parseInt( val, 10 );

		const newHvi = hviVal.map( (obj, index ) => 
			index === updatedIndex ? { ...obj, value: valInt } : obj
		);

		setHviVal( newHvi );

	}

	const handleCompletedPercentage = ( current, total ) => {
		return ((current+1)/total)*100
	}

	const getHviColor = (count) => {
		let color = 'sy-red';

		if ( count > 24 && count < 60 ) {
			color = 'sy-yellow';
		}

		if ( count > 59 ) {
			color = 'dark-green';
		}

		return color;
	}

	const saveUserHvi = async () => {

		if (!userEmail.toString().trim().length ) {
			setErrorMsg(translation("fill_required_fields"));

			return;
		
		}  else {
			setErrorMsg('');
		}

		setSaving( true );

		let userRequestData = new FormData();
        userRequestData.append( 'user_email', userEmail );
		userRequestData.append( 'si_data', JSON.stringify(hviVal) );

		if ( group ) {
			userRequestData.append( 'group', group );
		}

        const fetchUrl = `${configVars.apiUrl}sustainchange/v1/savesi/`;

        try{

            const response = await fetch(
                fetchUrl,
                {
                method: "POST",
                headers: {
                    Authorization: `Basic ${configVars.auth}`,
                },
                body: userRequestData
                }
            );
            
            const updateResponse = await response.json();
    
            if ( updateResponse ) {

				if ( updateResponse.success === true ) {

					if ( updateResponse.data.recent_hvi ) {

						setRecentHvi( [ updateResponse.data.recent_hvi ] );
						
						setWithExpiry( `sy_recent_si`, [ updateResponse.data.recent_hvi ] );
	
						setHviCount( updateResponse.data.recent_hvi.hvi_count );
						setCompleted(true);
	
					}

				} else {
					setErrorMsg( updateResponse.message );
				}

            }

        } catch( error ) {
            console.log( error );
            return error;
        }

		setSaving( false );

	}

	// const showResultsOnClose = () => {

	// 	if ( currentStep > 11 ) {

	// 		let totalHvi = 0;

	// 		hviVal.map( (hviItem, index) => {
	// 			if ( index < 12 ) {
	// 				totalHvi = totalHvi + hviItem.value;
	// 			}

	// 			return hviItem;
	// 		});

	// 		//setHviCount( totalHvi );
	// 		setDisplayCount(true);

	// 		let today = new Date().toISOString().slice( 0, 10 );

	// 		const newHvi = [
	// 			{
	// 				'data': hviVal,
	// 				'date': today,
	// 				'hvi_count': totalHvi,
	// 			}
	// 		];

	// 		setWithExpiry( `sy_recent_hvi`, newHvi );

	// 		//setRecentHvi( newHvi );
	// 	}

	// }

	if ( showResults ) {

		let apiLink = `${configVars.apiUrl}sustainchange/v1/getofflinesi/`;

		if ( group ) {
			apiLink = `${configVars.apiUrl}sustainchange/v1/getofflinesi/?group=${group}`;
		}

		return (
			<OfflineHVIResults
				questions={shortQuestions}
				titleOne="Sustain Index"
				titleTwo="Vårt SI"
				titleThree="Vårt SI - fördelning per fråga"
				titleFour="Vårt SI - antal per resultatkategori"
				titleFive="Vårt SI - antal per resultatkategori (procent)"
				apiLink={apiLink}
			/>
		)

	}

	return (
		<div className="main-wrapper">
			<Helmet>
				<title>Sustain Index</title>
				<meta name="description" content="" />
			</Helmet>
			<Navigation />

			<div className="page-content-wrap">
				<HorizontalNav title={translation("welcome")} />
				
				<div className="pt-5 pt-lg-0 page-content-inner">
					<div className="course-img-wrap d-flex overflow-hidden position-relative" style={{maxHeight: '300px',backgroundImage: `url(${hviCoverImg})`, backgroundSize: 'cover', backgroundPosition: 'center', height: '300px'}}>
						<div className="position-absolute w-100 h-100 top-0 left-0 dark-overlay d-flex justify-content-center align-items-center">
							<h1 className="text-white display-1 text-center text-shadow">Sustain Index</h1>
						</div>
					</div>

						<div className="px-4" style={{maxWidth: '1400px'}}>
							<div className="hvi-wrap mt-5">

								{loading &&
									<div className="spinner-border" role="status" >
										<span className="visually-hidden">Loading...</span>
									</div>
								}

								{ !displayTest &&
									<div>

										<div className="mb-4">
											<p>Med vårt Sustain Index kan du ta reda på om du är uppfylld av samma övertygelse som vi, att människor som mår bra i välfungerande organisationer också presterar bra på ett hållbart sätt. </p>
										</div>

										<div className="mb-4">
											<p>Testet består av tolv frågor och tar fem minuter. Dina svar behandlas helt konfidentiellt!</p>
										</div>

										<div className="mb-4">
											<button type="button" className="btn btn-halite-blue rounded-pill btn-lg px-5" onClick={()=> setDisplayTest(true)}>
												<i className="fa fa-life-ring" aria-hidden="true"></i>
												<span className="ms-3">{translation('go_to_test')}</span>
											</button>
										</div>

									</div>
								}

								{ translatedHvuQa && translatedHvuQa.length > 0 && !displayCount && !showResults && displayTest &&
									<>
										<div className="hvi-content mb-5">

											<div className="row">
												<div className="col-12 col-lg-9">

													{completed &&
														<>
															<div className="display-count-wrap d-flex align-items-center">
																<h3 className="h1 fw-bold me-2">{translation('your_hvi_is')}:</h3>
																<span className={`hvi-count text-white text-center h2 mb-0 py-3 bg-${getHviColor(hviCount)}`} style={{width: '150px'}}>{hviCount}</span>
															</div>
															<div className="mt-5">
																<HviMessages count={hviCount} color={getHviColor(hviCount)} lang={userLang} type="si" />
															</div>

															<HviPersonalSummary 
																isNew={false}
																userHvi={recentHvi}
																lang={userLang}
																type="si"
																questions={shortQuestions}
																textOne="Total SI"
															/>
														</>
													}

                                                    <div className="hvi-model">
                                                    { !showEmail && !completed &&
																<div className="toast show mb-5" role="alert" aria-live="assertive" aria-atomic="true">
																	<div className="toast-header">
																		<strong className="me-auto">Sustain Index</strong>
																		<small className="text-muted">{currentStep+1}/{translatedHvuQa.length}</small>
																	</div>
																	<div className="progress rounded-0" style={{height: '7px'}}>
																		<div className="progress-bar progress-bar-striped progress-bar-animated bg-sy-green rounded-0" role="progressbar" aria-valuenow={handleCompletedPercentage(currentStep, translatedHvuQa.length)} aria-valuemin="0" aria-valuemax="100" style={{width: `${handleCompletedPercentage(currentStep, translatedHvuQa.length)}%`}}></div>
																	</div>
																	<div className="toast-body">
																		<div className="hvi-single pb-4 mt-2">
																			<label >
																				<span className="fw-bold pe-2">{currentStep+1}</span>
																				<span>{translatedHvuQa[currentStep].question}</span>
																			</label>
																			{translatedHvuQa[currentStep].hints &&
																				<>
																					{translatedHvuQa[currentStep].hints.map( (hint, index) => {
																						return (
																							<div className="form-text ps-2" key={index}>{hint?.hint}</div>
																						)
																					})}
																					
																				</>
											
																			}
																			{translatedHvuQa[currentStep].type === 'numbers' &&
																				<Slider
																					value={hviVal[currentStep].value}
																					onChange={(value) => handleHviUpdate(value, currentStep)}
																					min={1}
																					max={6}
																					labels={hviLabels}
																				/>
																			}

																			{translatedHvuQa[currentStep].type === 'custom' && translatedHvuQa[currentStep].choices?.length > 0 &&
																				<div className="hvi-choices-wrap mt-3">
																					{ translatedHvuQa[currentStep].choices.map( (choice, index) => {
																						return (
																							<div className={`form-check ${translatedHvuQa[currentStep].display === 'inline' ? 'form-check-inline' : '' }`} key={index}>
																								<input 
																									className="form-check-input"
																									type="radio"
																									id={`${translatedHvuQa[currentStep].name}_${index}`} 
																									name={translatedHvuQa[currentStep].name} 
																									value={index}
																									checked={ hviVal[currentStep].value === index }
																									onChange={ (event) => { handleHviUpdate(event.target.value, currentStep) } }
																								/>
																								<label className="form-check-label" htmlFor={`${translatedHvuQa[currentStep].name}_${index}`}>{choice}</label>
																							</div>
																						)
																					}) }
																				</div>
																			}
																		</div>
																		<div className="mt-3 pt-3 border-top d-inline-block w-100">
																			{currentStep > 0 &&
																				<button type="button" className="btn btn-primary btn-sm text-white pe-4 ps-3" onClick={() => setCurrentStep(currentStep-1)}>
																					<i className="fa fa-angle-left" aria-hidden="true"></i>
																					<span className="ps-3">{translation('back')}</span>
																				</button>
																			}
																			{ (currentStep+1) < translatedHvuQa.length &&
																				<button type="button" className="btn btn-primary btn-sm float-end text-white ps-4 pe-3" onClick={() => setCurrentStep(currentStep+1)}>
																					<span className="pe-3">{translation('next')}</span>
																					<i className="fa fa-angle-right" aria-hidden="true"></i>
																				</button>
																			}
																			{ (currentStep+1) === translatedHvuQa.length &&
																				<button type="button" className="btn btn-sea-green btn-sm float-end text-white px-3" onClick={ () => setShowEmail(true) }>
																					<span>{translation('save')}</span>
																				</button>
																			}
															
																		</div>
																	</div>
																</div>
															}

															{showEmail && !completed &&
																<div className="save-offline-wrap pb-3" >
																	<div className="row">
																		<div className="col-12 mb-2">
																			<button type="button" className="btn btn-link p-0 mb-4" onClick={() => setShowEmail(false)}>
																				<i className="fa fa-long-arrow-left" aria-hidden="true"></i>
																				<span className="ps-2">{translation('back')}</span>
																			</button>
                                                                            <h3>{translation('one_step_left')}</h3>
																			<p>{translation('si_save_msg')}</p>
																		</div>
																	</div>
																	{ errorMsg.length > 0 &&
																		<div className="row">
																			<div className="col-12">
																				<p className="text-sy-red">{errorMsg === 'already_answered' ? translation(errorMsg) : errorMsg }</p>
																			</div>
																		</div>
																	}
																	<div className="row">
																		<div className="col-12 col-lg-7">
																			<input type="text" id="user_email" className="form-control bg-white" value={userEmail} placeholder={translation('your_email')} onChange={(e) => setUserEmail(e.target.value)} />
																		</div>
																		<div className="col-12 col-lg-5">
																			<button type="button" className="btn btn-sea-green btn-sm text-white px-3 py-2 mt-3 mt-lg-0" onClick={() => saveUserHvi()}>
																				<span>{translation('save')}</span>
																				{saving &&
																					<div className="spinner-border text-light spinner-border-sm ms-2" role="status" >
																						<span className="visually-hidden">Loading...</span>
																					</div>
																				}
																			</button>
																		</div>
																	</div>
																</div>
															}
                                                    </div>

													

												</div>
											</div>

											{/* <div className="mb-4 mt-4 text-center">
												<h3 className="fw-bold">Hur är testet framtaget?</h3>
												<p>Frågorna är formulerade utifrån utmaningar i vår samtid – stress, sömn, återhämtning, gränsen mellan arbete och fritid – plus två klassiska modeller, KASAM samt Karasek och Theorells krav-kontroll-stöd-modell.</p>
											</div> */}

											
										</div>
										
									</>
								}
							</div>
						</div>
				</div>

			</div>
		</div>
	);
};

export default SustainIndex;
